import { CavernsData } from 'dt-common/generated/zod';
import { logError } from '~/logger';
import messages, { CavernsStoreMessage } from '../messages';

export default async function onPlayerLoggedIn(
  {
    setPlayerId,
    setCavernsData,
    emit,
  }: {
    setPlayerId: (val: string) => void;
    setCavernsData: (val: CavernsData) => void;
    emit: (message: CavernsStoreMessage, data?: any) => void;
  },
  { player }: { player: { _id: string; gameState: { caverns_data: CavernsData } } }
) {
  try {
    setPlayerId(player._id);
    setCavernsData(player.gameState.caverns_data);

    // If player left the app during a caverns run, resume it
    for (const [submodeKey, submodeData] of Object.entries(player.gameState.caverns_data)) {
      if (!!submodeData.current_run) {
        emit(messages.UNFINISHED_CAVERNS_RUN, { submodeKey });
        setTimeout(() => {
          // timeout so that UINav to caverns screen can complete first
          emit(messages.ENTERED_CAVERNS, {
            game_submode: submodeKey,
            startingLevel: submodeData.current_run!.current_level,
            startingRoom: submodeData.current_run!.current_room,
            spawned_mobs: submodeData.current_run!.mobs,
            white_units: submodeData.current_run!.white_units,
          });
        }, 1000);
      }
    }
  } catch (err) {
    logError(err, {
      module: 'CavernsStore',
      func: 'onPlayerLoggedIn',
      player: JSON.stringify(player),
    });
  }
}
